import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const authenticatorRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/authenticator",
  component: lazyRouteComponent(() => import("./authenticator.page.js"), "AuthenticatorPage"),
});
